import { Outlet } from "react-router-dom";
import { AdminHeader } from "./Header/admin-header";

export const AdminHome = () => {
    return (
        <div className="bg-base-content min-h-screen text-neutral">
            <AdminHeader />
            <Outlet />
        </div>
    );
};
